module.exports = "/lucky-balls/img/infobox/info_Box_020.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_020.png
// module id = 1085
// module chunks = 0